import { useGlobalStates } from '../globalConstants';
import { Edit3 } from 'lucide-react';

export default function ScenarioDisplay() {
    const { difficultyLevel, scenario, setDisplayEditor, difficulty } = useGlobalStates();

    const rawText =
    scenario?.[difficultyLevel?.toLowerCase()] ??
    scenario?.scenario?.[difficultyLevel?.toLowerCase()] ??
    "";

    const preview = rawText
    .split(".")
    .slice(0, 3)
    .join(".")
    .trim();

    const displayText = preview && !preview.endsWith(".") ? preview + "." : preview;

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
            <div className='w-full justify-between items-center flex'>
                <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                    Current Scenario 
                </h3>   
                <div className="flex items-center space-x-2">
                    <span
                        role="button"
                        tabIndex={0}
                        onClick={(e) => {
                            e.stopPropagation();
                            setDisplayEditor(true);
                        }}
                        className="p-1 rounded-full hover:bg-current hover:bg-opacity-20 transition-colors cursor-pointer"
                        title="Edit scenario"
                    >
                        <Edit3 className="h-3 w-3" />
                    </span>
                    {difficultyLevel?.toLowerCase() === difficulty && (
                        <div className="w-2 h-2 rounded-full bg-current"></div>
                    )}
                </div>
            </div>
            <div className="space-y-2">
                <p className='text-xs text-gray-600 leading-relaxed'>
                    {displayText}
                </p>
            </div>
        </div>
    );
}